import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed inset-0 w-screen overflow-y-auto pt-6 sm:pt-0" }
const _hoisted_2 = { class: "grid min-h-full grid-rows-[1fr_auto_1fr] justify-items-center p-8 sm:grid-rows-[1fr_auto_3fr] sm:p-4" }

import {
		clsx,
	} from "clsx"

	import {
		Dialog,
		DialogPanel,
		TransitionChild,
		TransitionRoot,
	} from "@headlessui/vue"

	import {
		ref,
	} from "vue"

	
export default /*@__PURE__*/_defineComponent({
  __name: 'VAlert',
  props: {
		className: {
			type: String,
			default: "",
		},
		onClose: {
			type: Function,
			default: () => { return },
		},
		open: {
			type: Boolean,
			default: false,
		},
		size: {
			type: String,
			default: "md",
		},
		static: {
			type: Boolean,
			default: false,
		},
	},
  setup(__props) {

	const props = __props

	const dialogPanelRef = ref(null)

	const sizes: { [k: string]: string } = {
		xs: "sm:max-w-xs",
		sm: "sm:max-w-sm",
		md: "sm:max-w-md",
		lg: "sm:max-w-lg",
		xl: "sm:max-w-xl",
		"2xl": "sm:max-w-2xl",
		"3xl": "sm:max-w-3xl",
		"4xl": "sm:max-w-4xl",
		"5xl": "sm:max-w-5xl",
	}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TransitionRoot), {
    as: "template",
    show: __props.open
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Dialog), {
        as: "div",
        class: "relative z-50",
        "initial-focus": dialogPanelRef.value,
        static: __props.static,
        onClose: _cache[0] || (_cache[0] = ($event: any) => (__props.static ? null : __props.onClose()))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(TransitionChild), {
            as: "template",
            enter: "ease-out duration-100",
            "enter-from": "opacity-0",
            "enter-to": "opacity-100",
            leave: "ease-in duration-100",
            "leave-from": "opacity-100",
            "leave-to": "opacity-0"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("div", { class: "fixed inset-0 flex w-screen justify-center overflow-y-auto bg-zinc-950/15 px-2 py-2 focus:outline-0 sm:px-6 sm:py-8 lg:px-8 lg:py-16 dark:bg-zinc-950/50" }, null, -1)
            ])),
            _: 1,
            __: [1]
          }),
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_unref(TransitionChild), {
                as: "template",
                enter: "ease-out duration-100",
                "enter-from": "opacity-0 scale-95",
                "enter-to": "opacity-100 scale-100",
                leave: "ease-in duration-100",
                "leave-from": "opacity-100",
                "leave-to": "opacity-0"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(DialogPanel), {
                    ref_key: "dialogPanelRef",
                    ref: dialogPanelRef,
                    class: _normalizeClass(_unref(clsx)(
								__props.className,
								sizes[__props.size],
								'row-start-2 w-full rounded-2xl bg-white p-8 shadow-lg ring-1 ring-zinc-950/10 sm:rounded-2xl sm:p-6 dark:bg-zinc-900 dark:ring-white/10 forced-colors:outline'))
                  }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "default")
                    ]),
                    _: 3
                  }, 8, ["class"])
                ]),
                _: 3
              })
            ])
          ])
        ]),
        _: 3
      }, 8, ["initial-focus", "static"])
    ]),
    _: 3
  }, 8, ["show"]))
}
}

})